import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  name: 'youtubeStream'
})
export class YoutubeStreamPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {

  }
  transform(value: any, args?: any): SafeResourceUrl {
    console.log(value);
    let preLink = value.split("/")
    let videoLink = ""
    // 
    if (preLink[2] == "youtu.be") {
      videoLink = "https://www.youtube.com/embed/" + preLink[3]
    }
    else if (preLink[2] == "www.youtube.com" && preLink[3] == "embed") {
      videoLink = value
    }
    else if (preLink[2] == "www.youtube.com") {
      videoLink = "https://www.youtube.com/embed/" + preLink[3].split("=")[1]
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl(videoLink)

  }



}
